import type { WeightUomResponse } from '@views/screens/common/data-provider/weight-uom-list/api';

export const normalizeWeightUomList = (list: WeightUomResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.text,
    value: row.value,
  }));
};
